<template>
  <Expandable header="Hospital" class="mb-10">
    <b-row class="pb-0">
      <b-col cols="12" md="4">
        <!-- <input-field
          v-model.trim="form.hospital_name"
          label="Hospital Name"
          @input="input"
          :disabled="!isAdmin || isDisabled"
          dense
          rules="required|max-150"
        ></input-field> -->
           <input-field
          v-model.trim="form.hospital_name"
          label="Hospital Name"
          @input="input"
         
          dense
          rules="required|max-150"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <!-- Phase 1 Corrections - Label changed from "Hospital Type" to "Centre Type" -->
        <select-field
          v-model.trim="form.hospital_type"
          label="Centre Type"
          :disabled="isHospitalTypeDisabled"
          @input="input"
          :items="masterHospitalTypes"
          rules="required"
        ></select-field>
      </b-col>
      <b-col cols="12" md="4">
        <!-- Phase 1 Corrections - Website URL is now non-mandatory -->
        <input-field
          v-model.trim="form.website_url"
          :disabled="isDisabled"
          label="Website URL"
          @input="input"
          rules="url"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <autocomplete
          @input="input"
          v-model="form.year_of_establishment"
          label="Year Of Establishment"
          :disabled="isDisabled"
          :items="years"
          rules="required"
        ></autocomplete>
      </b-col>
      <b-col cols="12" md="4">
        <!-- Phase 1 Corrections - Label changed from "Hospital License No" to "Hospital Trade License Number" -->
        <input-group
          v-model.trim="form.hospital_registration_no"
          @input="input"
          label="Hospital Trade License Number"
          counter="100"
      
          :disabled="isDisabled"
          outlined
          dense
        >
          <template v-slot:help>
            <help text="Hospital Trade License Number"></help>
          </template>
        </input-group>
      </b-col>
      <b-col cols="12" md="4">
        <select-field
          @input="input"
          v-model.trim="form.zone_id"
          :disabled="isDisabled"
          label="Zone"
          :items="masterZones"
          rules="required"
        ></select-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-group
          v-model.trim="form.kpme_number"
          @input="input"
          label="KPME Number"
          counter="50"
          :rules="form.hospital_type != 1 ? 'required|max-50' : 'max-50'"
          :disabled="isDisabled"
          outlined
          dense
        >
          <template v-slot:help>
            <help text="Karnataka Private Medical Establishment Registration Number (Mandatory for Private Hospitals)"></help>
          </template>
        </input-group>
        <b-button
          v-if="!isDisabled && form.kpme_number"
          size="sm"
          variant="primary"
          :disabled="verifyingKPME"
          @click="verifyKPMECertificate"
          class="mt-1"
        >
          <b-spinner small v-if="verifyingKPME" class="mr-1"></b-spinner>
          {{ verifyingKPME ? "Verifying..." : "Verify with KPME" }}
        </b-button>
        <b-alert
          v-if="kpmeVerificationStatus"
          show
          :variant="kpmeVerificationStatus.success ? 'success' : 'danger'"
          class="mt-2 py-1 px-2"
        >
          <small>
            {{ kpmeVerificationStatus.msg }}
            <span v-if="kpmeVerificationStatus.establishment_name">
              <br /><strong>Establishment:</strong> {{ kpmeVerificationStatus.establishment_name }}
            </span>
            <span v-if="kpmeVerificationStatus.valid_upto">
              <br /><strong>Valid Upto:</strong> {{ kpmeVerificationStatus.valid_upto }}
            </span>
          </small>
        </b-alert>
      </b-col>
      <!-- Phase 1 Corrections - New field for KPME Validity Date -->
      <b-col cols="12" md="4" v-if="form.kpme_number">
        <date-picker
          v-model="form.kpme_validity_date"
          @input="input"
          label="KPME Validity/Expiry Date"
          :disabled="isDisabled"
        ></date-picker>
      </b-col>
      <b-col cols="12" md="4">
        <input-group
          v-model.trim="form.hfr_number"
          @input="input"
          label="HFR Number(Health Facility Registry)"
          counter="50"
          rules="max-50"
          :disabled="isDisabled"
          outlined
          dense
        >
          <template v-slot:help>
            <help text="Health Facility Registry (HFR) Number"></help>
          </template>
        </input-group>
      </b-col>
      <!-- Phase 1 Corrections - Registered For dropdown (Point 7 in requirements) -->
      <b-col cols="12" md="4">
        <select-field
          @input="input"
          v-model.trim="form.registered_for"
          :disabled="isDisabled"
          label="Registered For"
          :items="registeredForOptions"
          rules="required"
        ></select-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.hospital_email_id"
          label="Email"
          @input="input"
          :disabled="isDisabled"
          rules="required|email|max-100"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <phone-field
          v-model.trim="form.hospital_phone_number_1"
          :defaultCountry="form.hospital_country_code_1"
          label="Phone Number 1"
          :disabled="isDisabled"
          @input="input"
          @onCountryCode="form.hospital_country_code_1 = $event"
          rules="required|integer"
        ></phone-field>
      </b-col>
      <b-col cols="12" md="4">
        <phone-field
          v-model.trim="form.hospital_phone_number_2"
          :defaultCountry="form.hospital_country_code_2"
          label="Phone Number 2"
          :disabled="isDisabled"
          @input="input"
          @onCountryCode="form.hospital_country_code_2 = $event"
          rules="integer"
        ></phone-field>
      </b-col>
      <!-- Payment disabled for Phase 1 -->
      <b-col cols="12" md="4" v-if="false && form.hospital_type != 1">
        <input-field
          v-model.trim="form.payment_reference_no"
          label="Payment Reference No"
          @input="input"
          :disabled="true"
          rules=""
        >
          <!-- <template v-slot:help>
            <b-button @click="openPayment()" variant="primary"
              >Payment Link</b-button
            >
          </template> -->
        </input-field>
      </b-col>
    </b-row>
  </Expandable>
</template>

<script>
import {
  FIELD,
  getMaxEmailRules,
  getMaxRules,
  URL_RULES,
} from "../../../assets/js/rules";
import hospitalCreateMixins from "../../../assets/mixins/hospital.create.mixins";
import Expandable from "../../Expandable.vue";
import SelectField from "../../form/SelectField.vue";
import Autocomplete from "../../form/Autocomplete.vue";
import Help from "../../Help.vue";
import PhoneField from "../../form/PhoneField.vue";
import DatePicker from "../../form/DatePicker.vue";
import { PAYMENT_LINK } from "../../../assets/js/common";
import hospitalService from "../../../assets/services/hospital.service";
export default {
  props: {
    value: Object,
    status: Number,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [hospitalCreateMixins],
  components: {
    Expandable,
    SelectField,
    Autocomplete,
    PhoneField,
    DatePicker,
    Help,
  },
  data() {
    return {
      rules: FIELD,
      phone: FIELD,
      phone2: [],
      urlRules: URL_RULES,
      // Phase 1 Corrections - Hardcoded options for "Registered For" dropdown
      verifyingKPME: false,
      kpmeVerificationStatus: null,
      registeredForOptions: [
        { name: "NTORC", value: 1 },
        { name: "OTC", value: 2 },
        { name: "Tissue Bank", value: 3 },
        { name: "Eye Bank", value: 4 },
        { name: "Cornea Transplant Centre", value: 5 },
      ],
      form: {
        hospital_name: "",
        hospital_type: "",
        hospital_email_id: "",
        hospital_country_code_1: "91",
        hospital_phone_number_1: "",
        hospital_country_code_2: "91",
        hospital_phone_number_2: "",
        hospital_registration_no: "",
        year_of_establishment: "",
        website_url: "",
        zone_id: "",
        kpme_number: "",
        kpme_validity_date: "",  // Phase 1 Corrections - New field
        hfr_number: "",
        registered_for: "",  // Phase 1 Corrections - Registered For field
      },
    };
  },
  computed: {
    master() {
      return this.$store.getters.master;
    },
    years() {
      let year = 1899;
      let list = [];
      while (year < new Date().getFullYear()) {
        year++;
        list.push({
          name: year.toString(),
          value: year.toString(),
        });
      }
      return list.reverse();
    },
    isHospitalTypeDisabled() {
      return this.isDisabled || this.status == 2;
    },
  },
  methods: {
    openPayment() {
      window.open(PAYMENT_LINK, "_blank");
    },
    getMaxRules(max) {
      return getMaxRules(max);
    },
    getMaxEmailRules(max) {
      return getMaxEmailRules(max);
    },
    input() {
      this.$emit("input", this.form);
    },
    async verifyKPMECertificate() {
      if (!this.form.kpme_number) return;
      this.verifyingKPME = true;
      this.kpmeVerificationStatus = null;
      try {
        let { data } = await hospitalService.verifyKPME(this.form.kpme_number);
        if (data.status) {
          this.kpmeVerificationStatus = {
            success: true,
            msg: data.msg,
            establishment_name: data.establishment_name,
            valid_upto: data.certificate_valid_upto,
          };
          // Auto-fill validity date if available
          if (data.certificate_valid_upto) {
            this.form.kpme_validity_date = data.certificate_valid_upto;
            this.input();
          }
        } else {
          this.kpmeVerificationStatus = {
            success: false,
            msg: data.msg || "Verification failed",
          };
        }
      } catch (e) {
        this.kpmeVerificationStatus = {
          success: false,
          msg: "Error verifying KPME certificate",
        };
      } finally {
        this.verifyingKPME = false;
      }
    },
    isKpmeVerified() {
      // KPME is required for private hospitals (hospital_type != 1)
      if (this.form.hospital_type == 1) return true;
      if (!this.form.kpme_number) return true;
      return this.kpmeVerificationStatus != null && this.kpmeVerificationStatus.success === true;
    },
    init() {
      const vm = this;
      Object.keys(vm.value).forEach((key) => {
        vm.$set(vm.form, key, vm.value[key]);
      });
      vm.form.year_of_establishment = vm.form.year_of_establishment.toString();
      if (vm.$route.name == "hospital-registration" && vm.user.user_type == 1) {
        vm.form.hospital_name = vm.user.hospital_name;
      }
    },
    onPhoneInput1(item, doc) {
      const vm = this;
      vm.phone = [
        (v) => !!v || "This field is required",
        doc.isValid || "Enter valid phone number",
      ];
      if (doc.country.dialCode !== undefined) {
        vm.form.hospital_country_code_1 = doc.country.dialCode;
      }
      if (doc.number.significant !== undefined) {
        vm.form.hospital_phone_number_1 = doc.number.significant;
      }
      vm.input();
    },
    onPhoneInput2(item, doc) {
      const vm = this;
      if (doc.number.significant) {
        vm.phone2 = [doc.isValid || "Enter valid phone number"];
      } else {
        vm.phone2 = [];
      }
      if (doc.country.dialCode !== undefined) {
        vm.form.hospital_country_code_2 = doc.country.dialCode;
      }
      if (doc.number.significant !== undefined) {
        vm.form.hospital_phone_number_2 = doc.number.significant;
      }
      vm.input();
    },
  },

  beforeMount() {
    this.init();
    this.input();
  },
};
</script>

<style></style>
